import { Controller } from "@hotwired/stimulus";

// Cale le sélecteur de date sur la période d'évaluation choisie : le
// calendrier s'ouvre sur le mois de la période et n'offre que ses jours.
// Sans cela il s'ouvrait sur aujourd'hui, hors période dès que l'année
// scolaire affichée n'est pas l'année en cours (le modèle refuse la date).
export default class extends Controller {
  static targets = ["period", "date", "hint"];
  // startDate / endDate : bornes de la période quand elle est verrouillée
  // (évaluation déjà enregistrée, plus de liste déroulante).
  static values = { hintText: String, startDate: String, endDate: String };

  connect() {
    // La liste des périodes est remplacée par un turbo-stream au changement
    // de trimestre : aucun « change » n'est émis à ce moment-là.
    this.observer = new MutationObserver(() => this.apply());
    if (this.hasPeriodTarget) {
      this.observer.observe(this.periodTarget, { childList: true, subtree: true });
    }
    // Le flatpickr du champ date se connecte après ce contrôleur parent.
    requestAnimationFrame(() => this.apply());
  }

  disconnect() {
    this.observer?.disconnect();
  }

  apply() {
    const option = this.hasPeriodTarget
      ? this.periodTarget.querySelector("select")?.selectedOptions[0]
      : null;
    const start = this.hasPeriodTarget ? option?.dataset.startDate || "" : this.startDateValue;
    const end = this.hasPeriodTarget ? option?.dataset.endDate || "" : this.endDateValue;
    this.updateHint(start, end);

    const picker = this.hasDateTarget ? this.dateTarget._flatpickr : null;
    if (!picker) return;

    const current = picker.selectedDates[0];
    picker.set("minDate", start || null);
    picker.set("maxDate", end || null);
    if (!start || !end) return;

    // Une date hors période ne peut pas être enregistrée : on la retire
    // plutôt que de laisser l'utilisateur la soumettre.
    if (current && (current < picker.parseDate(start, "Y-m-d") || current > picker.parseDate(end, "Y-m-d"))) {
      picker.clear();
    }
    if (!picker.selectedDates.length) picker.jumpToDate(start);
  }

  updateHint(start, end) {
    if (!this.hasHintTarget) return;

    const show = Boolean(start && end);
    this.hintTarget.classList.toggle("hidden", !show);
    if (show) {
      this.hintTarget.textContent = this.hintTextValue
        .replace("%{from}", this.format(start))
        .replace("%{to}", this.format(end));
    }
  }

  format(dateStr) {
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  }
}
